import LoadingButton from 'atoms/LoadingButton';
import cn from 'classnames';
import React, { useState } from 'react';
import { OrderType } from 'stores/networkInterfaces';
import { useStore } from 'stores/store';
import { IOfferingInfo } from 'utils/globalTypes';
import { navigateToOrder } from 'utils/navigateUtils';

import s from './InvestmentStats.module.scss';

interface IInvestmentStats {
  className?: string;
  item: IOfferingInfo;
}

const InvestmentStats = ({ className, item }: IInvestmentStats) => {
  const { InvestmentStore } = useStore();
  const [isSellLoading, setIsSellLoading] = useState(false);
  const [isBuyLoading, setIsBuyLoading] = useState(false);

  const {
    offering_id,
    volume_pending_int_buy_investor: volumePendingIntBuyInvestor,
    volume_pending_bid_buy_investor: volumePendingBidBuyInvestor,
    volume_pending_bid_sell_investor: volumePendingBidSellInvestor
  } = item;

  const goToOrder = (orderType: OrderType) => {
    return async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      if (!offering_id) return;
      try {
        if (orderType === OrderType.bid_sell) {
          setIsSellLoading(true);
        } else {
          setIsBuyLoading(true);
        }
        const order = await InvestmentStore.getActiveOrder(offering_id, orderType);
        navigateToOrder(offering_id, order?.id, orderType);
      } catch (e) {
        setIsSellLoading(false);
        setIsBuyLoading(false);
      }
    };
  };

  return (
    <div className={cn(s.InvestmentStats, className)}>
      {volumePendingBidSellInvestor && (
        <LoadingButton
          variant="outlined"
          size="small"
          loading={isSellLoading}
          onClick={goToOrder(OrderType.bid_sell)}
          className={cn(s.InvestmentStats__label, 'bid_sell')}
        >
          {'My Ask'}
        </LoadingButton>
      )}
      {volumePendingIntBuyInvestor && (
        <LoadingButton
          variant="outlined"
          size="small"
          loading={isBuyLoading}
          onClick={goToOrder(OrderType.int_buy)}
          className={cn(s.InvestmentStats__label, 'int_buy')}
        >
          {'My Investment'}
        </LoadingButton>
      )}
      {volumePendingBidBuyInvestor && (
        <LoadingButton
          variant="outlined"
          size="small"
          loading={isBuyLoading}
          onClick={goToOrder(OrderType.bid_buy)}
          className={cn(s.InvestmentStats__label, 'bid_buy')}
        >
          {'My Bid'}
        </LoadingButton>
      )}
    </div>
  );
};

export default InvestmentStats;
